export const boardData = [
  {
    id: 0,
    name: "Natural Maple",
    price: "75",
    src: "skateboard-04.glb",
    thumbSrc: "skateboard-04-thumb.png",
  },
  {
    id: 1,
    uid: "jwodis0",
    name: "Black & White Mandala by Zandiepants",
    price: "63",
    src: "skateboard-05.glb",
    thumbSrc: "skateboard-05-thumb.png",
  },
  {
    id: 2,
    uid: "0pkneuej",
    name: "Magic Elephant by Aaron Glasson",
    price: "65",
    src: "skateboard-07.glb",
    thumbSrc: "skateboard-07-thumb.png",
  },
  {
    id: 3,
    uid: "18udnsaoi",
    name: "Monster Hand by Santa Cruz Skateboards",
    price: "65",
    src: "skateboard-10.glb",
    thumbSrc: "skateboard-10-thumb.png",
  },
  {
    id: 4,
    uid: "9skahfiej",
    name: "Revenge Bear Deck by Aaron Glasson",
    price: "95",
    src: "skateboard-06.glb",
    thumbSrc: "skateboard-06-thumb.png",
  },
  {
    id: 5,
    uid: "8akshduhf",
    name: "Magic Owl by Aaron Glasson",
    price: "65",
    src: "skateboard-12.glb",
    thumbSrc: "skateboard-12-thumb.png",
  },
  {
    id: 6,
    uid: "oakshiajs",
    name: "Checkerboard by Jad",
    price: "75",
    src: "skateboard-11.glb",
    thumbSrc: "skateboard-11-thumb.png",
  },
  {
    id: 7,
    uid: "7duduhso",
    name: "Rob Roskopp Classic from Santa Cruz Skateboards",
    price: "75",
    src: "skateboard-09.glb",
    thumbSrc: "skateboard-09-thumb.png",
  },
  {
    id: 8,
    uid: "a8suhwmmij",
    name: "45 RPM by Seven Inch Skateboards",
    price: "95",
    src: "skateboard-08.glb",
    thumbSrc: "skateboard-08-thumb.png",
  },
]
